import { ISetSettingsRequest } from '../../repositories/cian-chat-bot/entities/settings/SetSettingsRequest';
import {
  fetchPublicMobileV1SetSettings,
  TPublicMobileV1SetSettingsResponse,
} from '../../repositories/cian-chat-bot/mobile/v1/set-settings';
import { TContext } from '../../types/context';
import { EExceptionDomain } from '../../types/exceptionDomains';
import { getGenericLikeError } from '../../utils/logging/getGenericLikeError';
import { getResponseError } from '../../utils/logging/getResponseError';

type TChatbotSetSettingsContext = Pick<TContext, 'httpApi' | 'logger'>;

type TProps = Pick<ISetSettingsRequest, 'periodicity'>;

const DEFAULT_ERROR_MESSAGE = 'Ошибка при сохранении настроек чатбота';

export async function chatbotSetSettings({ httpApi, logger }: TChatbotSetSettingsContext, { periodicity }: TProps) {
  try {
    const { response, statusCode }: TPublicMobileV1SetSettingsResponse = await fetchPublicMobileV1SetSettings({
      httpApi,
      parameters: {
        periodicity,
      },
    });

    if (statusCode !== 200) {
      throw getResponseError({
        domain: EExceptionDomain.Chatbot,
        response,
        defaultMessage: DEFAULT_ERROR_MESSAGE,
        statusCode,
      });
    }

    return response.messages;
  } catch (error) {
    const exception = getGenericLikeError({
      error,
      domain: EExceptionDomain.Chatbot,
      message: DEFAULT_ERROR_MESSAGE,
    });

    logger.error(exception, {
      microserviceName: 'cian-chat-bot',
      pathApi: '/mobile/v1/set-settings/',
      parameters: JSON.stringify({ periodicity }),
    });

    return null;
  }
}
